import parse, { domToReact } from "html-react-parser";
import Head from "next/head";
import { gql } from "urql";
import { client } from "../../../graphql/client";
import { cssAppliedContent } from "../../../utils/cssAppliedContent";

const getQuery = async (url) => {
  const query = gql`
    query MyQuery($url: String) {
      cms_news(where: { url: { _like: $url } }) {
        id
        title
        description
        url
      }
    }
  `;

  const { data } = await client.query(query, { url: url }).toPromise();
  return data;
};

export async function getServerSideProps(context) {
  const { params } = context;
  const { id } = params;

  const data = await getQuery(id);

  return { props: { data: data || null } };
}

export default function id({ data }) {
  const schemeData = {
    "@type": "Berita",
    data: data.cms_news[0],
  };

  return (
    <main className="h-full w-full bg-[#F3F7FA] py-20 px-4">
      <Head>
        <title>{data?.cms_news[0]?.title}</title>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemeData),
          }}
        />
      </Head>
      {data?.cms_news.map((item) => (
        <div className="mx-auto mt-[100px] w-full max-w-[1260px]" key={item.id}>
          <h1 className="text-center font-nunito text-2xl font-extrabold text-[#333333]">
            {item.title}
          </h1>
          <div className="mt-8 w-full">
            <div
              className="prose !max-w-full"
              dangerouslySetInnerHTML={{
                __html: cssAppliedContent(item?.description),
              }}
            ></div>
            {/* {parse(item.description, {
              replace: ({ attribs, children }) => {
                if (!attribs) {
                  return;
                }
                if (attribs.href) {
                  return (
                    <a
                      style={{ color: "blue" }}
                      href={attribs.href}
                      target="_blank"
                    >
                      {domToReact(children)}
                    </a>
                  );
                }
              },
            })} */}
          </div>
        </div>
      ))}
    </main>
  );
}
